import { z } from 'zod'
import type { LayerAssignment, LayerAssignmentBatchResult } from '#/domain/catalog/LayerAssignment'
import type {
  BatchAssignLayersResultDto as BatchAssignLayersResultDtoSpec,
  LayerAssignmentDto as LayerAssignmentDtoSpec,
  LayerAssignmentFailureDto as LayerAssignmentFailureDtoSpec,
} from '#/infrastructure/api/generated'
import type { Assert, SpecContract } from '#/infrastructure/api/SpecContract'

export const LayerAssignmentDtoSchema = z
  .object({
    LayerId: z.string(),
    LayerCategoryId: z.string(),
    LayerCategoryName: z.string().optional(),
    DisplayOrder: z.number(),
    Zindex: z.number(),
  })
  .transform((raw): LayerAssignment => ({
    LayerId: raw.LayerId,
    LayerCategoryId: raw.LayerCategoryId,
    LayerCategoryName: raw.LayerCategoryName,
    DisplayOrder: raw.DisplayOrder,
    Zindex: raw.Zindex,
  }))

export type LayerAssignmentResponseDto = z.input<typeof LayerAssignmentDtoSchema>
export type LayerAssignmentDtoSpecContract = Assert<
  SpecContract<LayerAssignmentResponseDto, LayerAssignmentDtoSpec>
>

export function toDomain(raw: LayerAssignmentResponseDto): LayerAssignment {
  return LayerAssignmentDtoSchema.parse(raw)
}

export const LayerAssignmentBatchResultDtoSchema = z
  .object({
    Assigned: z.array(LayerAssignmentDtoSchema),
    Failed: z.array(z.object({ LayerId: z.string(), Reason: z.string() })),
  })
  .transform(
    (raw): LayerAssignmentBatchResult => ({
      Assigned: raw.Assigned,
      Failed: raw.Failed,
    }),
  )

export type LayerAssignmentBatchResultResponseDto = z.input<typeof LayerAssignmentBatchResultDtoSchema>
export type LayerAssignmentBatchResultDtoSpecContract = Assert<
  SpecContract<LayerAssignmentBatchResultResponseDto, BatchAssignLayersResultDtoSpec>
>
export type LayerAssignmentFailureDtoSpecContract = Assert<
  SpecContract<
    LayerAssignmentBatchResultResponseDto['Failed'][number],
    LayerAssignmentFailureDtoSpec
  >
>

export function toDomainBatch(
  raw: LayerAssignmentBatchResultResponseDto,
): LayerAssignmentBatchResult {
  return LayerAssignmentBatchResultDtoSchema.parse(raw)
}
